import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { withModulesManager, withHistory } from "@openimis/fe-core";
import InsureeAccountClaimSearcher from "../../components/InsureeAccountClaimSearcher";

const styles = (theme) => ({
  page: theme.page,
});

class InsureeAccountClaimHomePage extends Component {
  onDoubleClick = (enrollment) => {
    if (this.props.history && enrollment?.uuid) {
      this.props.history.push(`/enrollment/account-claim/${enrollment.uuid}/detail`);
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.page}>
        <InsureeAccountClaimSearcher
          cacheFiltersKey="enrollmentAccountClaimPageFiltersCache"
          onDoubleClick={this.onDoubleClick}
        />
      </div>
    );
  }
}

export default injectIntl(
  withModulesManager(
    withHistory(withTheme(withStyles(styles)(InsureeAccountClaimHomePage)))
  )
);
